import React, { useState, useContext, useEffect } from 'react';
import './DateTimeWidget.css';
import DateTimeFooter from '@React_UI_Lib/DateTimeFooter';
import DateTimePicker from '@React_UI_Lib/DateTimePicker';
import {
  OUTSTATION_ROUND_TRIP,
  OUTSTATION
} from '../../../../constants/tripTypes';
import {
  SET_TRAVELFOR,
  SET_DEPT_DATE,
  SET_RETURN_DATE
} from '../../cabsLandingPageState';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../../CabsLandingContext';
import { getAppEnv } from '../../../../../config/env';
import {
  datePlusOne,
  getNearestNMinSlot,
  timePlusNHrs
} from '../../../../utils/timeUtils';
const dayjs = require('dayjs');

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;
const PICKUP = 'pickUp';
const DROPUP = 'dropUp';
const timeErrorDateFormat = 'MMM DD, hh:mm a';
export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const DateAndTime = ({
  onClick,
  dropWidgetOpen
}: {
  onClick: () => void;
  dropWidgetOpen: boolean;
}) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);

  const setSelectedDropDate = (dropDate: Date) => {
    dispatch && dispatch({ type: SET_DEPT_DATE, newStateValue: dropDate });
  };
  const setSelectedReturnDate = (pickupDate: Date) => {
    dispatch && dispatch({ type: SET_RETURN_DATE, newStateValue: pickupDate });
  };
  const setTripTypeRT = () => {
    dispatch &&
      dispatch({ type: SET_TRAVELFOR, newStateValue: OUTSTATION_ROUND_TRIP });
  };
  const {
    selectedDeptDate,
    selectedReturnDate,
    stopOvers,
    travelFor
  } = cabsLandingContext;

  const minPickUpDate = getNearestNMinSlot(timePlusNHrs(new Date(), 1), 15);
  const minDropDate = getNearestNMinSlot(timePlusNHrs(selectedDeptDate, 12), 5);

  const [isActive, setIsActive] = useState(dropWidgetOpen ? DROPUP : PICKUP);
  const [isInValidDate, setIsInValidDate] = useState(false);
  const [isDropSelected, setIsDropSelected] = useState(false);
  const isPickUpActive = isActive === PICKUP;
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isAddReturnDate, setIsAddReturnDate] = useState(false);
  const isOutstationTrip = travelFor.includes(OUTSTATION);

  const showPickupAndDropDate =
    travelFor === OUTSTATION_ROUND_TRIP ||
    (travelFor.includes(OUTSTATION) && stopOvers.length > 0);

  const [showDropDetails, setShowDropDetails] = useState(showPickupAndDropDate);

  const unsetErrorMessageWithDelay = () => {
    setTimeout(() => {
      setErrorMessage(null);
    }, 2000);
  };

  useEffect(() => {
    if (errorMessage) {
      unsetErrorMessageWithDelay();
    }
  }, [errorMessage]);

  const pickupTimeErrorMessage = () => {
    return `Minimum pickup time should be ${dayjs(minPickUpDate).format(
      timeErrorDateFormat
    )}`;
  };

  const dropTimeErrorMessage = () => {
    return `Minimum drop time should be ${dayjs(minDropDate).format(
      timeErrorDateFormat
    )}`;
  };

  const updatePickupDate = (newDate: Date) => {
    if (newDate < minPickUpDate) {
      setErrorMessage(pickupTimeErrorMessage());
      unsetErrorMessageWithDelay();
      return;
    }
    setSelectedDropDate(newDate);
    if (newDate >= selectedReturnDate) {
      setSelectedReturnDate(getNearestNMinSlot(timePlusNHrs(newDate, 12), 5));
    }
  };

  const updateDropDate = (newDate: Date) => {
    if (newDate < minDropDate) {
      setErrorMessage(dropTimeErrorMessage());
      return;
    }
    setSelectedReturnDate(newDate);
  };
  const dateTimeInfo = date => {
    const isHourGreaterThan12 = date.getHours() >= 12;
    return {
      day: date.getDate(),
      month: date.getMonth(),
      year: date.getFullYear(),
      hour: isHourGreaterThan12
        ? date.getHours() === 12
          ? 12
          : date.getHours() - 12
        : date.getHours(),
      minute: date.getMinutes(),
      ampm: isHourGreaterThan12 ? 'PM' : 'AM'
    };
  };

  const pickUpDetail = {
    label: 'PICK UP DATE & TIME',
    subInfo: `${String(dateTimeInfo(selectedDeptDate)['day']).padStart(
      2,
      '0'
    )} ${MONTHS[dateTimeInfo(selectedDeptDate)['month']]} ${
      dateTimeInfo(selectedDeptDate)['year']
    } - ${String(dateTimeInfo(selectedDeptDate)['hour']).padStart(
      2,
      '0'
    )}:${String(dateTimeInfo(selectedDeptDate)['minute']).padStart(2, '0')} ${
      dateTimeInfo(selectedDeptDate)['ampm']
    }`
  };

  const dropDetail = {
    label: 'DROP DATE & TIME',
    subInfo: `${String(dateTimeInfo(selectedReturnDate)['day']).padStart(
      2,
      '0'
    )} ${MONTHS[dateTimeInfo(selectedReturnDate)['month']]} ${
      dateTimeInfo(selectedReturnDate)['year']
    } - ${String(dateTimeInfo(selectedReturnDate)['hour']).padStart(
      2,
      '0'
    )}:${String(dateTimeInfo(selectedReturnDate)['minute']).padStart(2, '0')} ${
      dateTimeInfo(selectedReturnDate)['ampm']
    }`
  };

  const dtDropOnClick = () => {
    setIsActive(DROPUP);
    setIsDropSelected(true);
    if (isAddReturnDate) {
      setSelectedReturnDate(datePlusOne(selectedDeptDate));
      setIsAddReturnDate(false);
      setShowDropDetails(true);
    }
  };

  const dtPickUpOnClick = () => {
    setIsActive(PICKUP);
  };

  useEffect(() => {
    if (isOutstationTrip && !showDropDetails) setIsAddReturnDate(true);
  }, []);

  return (
    <div className="dateAndTimeContainer">
      <div className="dateAndTimeHeader">
        <div className="dateAndTimeWrapper">
          <img
            className="BackIc"
            src={`${PUBLIC_URL}/static/public/backIc.png`}
            onClick={onClick}
          />
          <span>Select Travel Date & Time</span>
        </div>
      </div>

      <DateTimePicker
        minDate={isPickUpActive ? minPickUpDate : minDropDate}
        date={isPickUpActive ? selectedDeptDate : selectedReturnDate}
        onDateChange={isPickUpActive ? updatePickupDate : updateDropDate}
        setIsInValidDate={setIsInValidDate}
        isInValidDate={isInValidDate}
        isPickUpActive={isPickUpActive}
        isActive={isActive}
        dtDateLabel={isPickUpActive ? '*Pick Up* Date' : '*Drop* Date'}
        dtTimeLabel={isPickUpActive ? '*Pick Up* Time' : '*Drop* Time'}
      />
      {errorMessage ? (
        <div
          style={{
            width: '340px',
            marginLeft: 'auto',
            marginRight: 'auto',
            left: 0,
            right: 0,
            zIndex: 2,
            position: 'absolute',
            bottom: '170px',
            borderRadius: '6px',
            padding: '10px 16px'
          }}
          className="blackBackGroundColor whiteText appendTop10 horizontalCenter"
        >
          {errorMessage}
        </div>
      ) : null}
      <DateTimeFooter
        pickUpDetail={pickUpDetail}
        dropDetail={isOutstationTrip && showDropDetails ? dropDetail : null}
        dtDropOnClick={dtDropOnClick}
        dtPickUpOnClick={dtPickUpOnClick}
        isPickUpActive={isPickUpActive}
        isDisable={isInValidDate ? (isPickUpActive ? DROPUP : PICKUP) : null}
        onBtnClick={() => {
          if (isDropSelected && showDropDetails) {
            setTripTypeRT();
          }
          onClick();
        }}
        isBtnDisable={isInValidDate ? true : false}
        btnTxt="Done"
        addReturnDate={isAddReturnDate}
        crossIcon={
          isOutstationTrip && !isAddReturnDate && !showPickupAndDropDate
            ? `${PUBLIC_URL}/static/public/cross_img.png`
            : ''
        }
        onCrossClick={e => {
          dtPickUpOnClick();
          setIsAddReturnDate(true);
          setShowDropDetails(false);
          e.stopPropagation();
        }}
      />
    </div>
  );
};

export default DateAndTime;
